import React from 'react';

export default function LearnNotebookFilters({
  searchQuery,
  onSearchChange,
  subtopics,
  selectedSubtopic,
  onSubtopicChange,
  selectedDifficulty,
  onDifficultyChange,
  totalShown,
  totalCount,
}) {
  return (
    <section className="learn-notebook-filters" aria-label="Filter questions">
      <header className="learn-filter-head">
        <h3 className="learn-filter-head-title">Filter questions</h3>
        <p className="learn-filter-count" aria-live="polite">
          Showing {totalShown} of {totalCount}
        </p>
      </header>
      <div className="learn-filter-grid">
        <div className="learn-filter-field learn-filter-search">
          <label htmlFor="nb-search">Search</label>
          <input
            id="nb-search"
            type="search"
            className="learn-filter-input"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Keyword in question or answer…"
            autoComplete="off"
          />
        </div>
        <div className="learn-filter-field">
          <label htmlFor="nb-sub">Subtopic</label>
          <select
            id="nb-sub"
            className="learn-filter-select"
            value={selectedSubtopic}
            onChange={(e) => onSubtopicChange(e.target.value)}
          >
            <option value="">All subtopics</option>
            {subtopics.map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>
        </div>
        <div className="learn-filter-field">
          <label htmlFor="nb-diff">Difficulty</label>
          <select
            id="nb-diff"
            className="learn-filter-select"
            value={selectedDifficulty}
            onChange={(e) => onDifficultyChange(e.target.value)}
          >
            <option value="">All levels</option>
            <option value="BEGINNER">Beginner</option>
            <option value="INTERMEDIATE">Intermediate</option>
            <option value="ADVANCED">Advanced</option>
          </select>
        </div>
      </div>
    </section>
  );
}
